import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "NewFundsVerification" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { toDay } from '@/utils/date-format'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus/es'
import { editPageData } from '@/service/main/system'
import { modalConfig } from './config/modal.config'
import PageModal from '@/components/PageModal.vue'
import { initEmptyParam } from '@/hooks/useInitParam'
import localCache from '@/utils/cache'
import dayjs from 'dayjs'
import { usePermission } from '@/hooks/usePermission'

const pageName = 'newFundsVerification'

export default /*#__PURE__*/_defineComponent({
  __name: 'FundsVerification',
  setup(__props) {

initEmptyParam()
let query = {}
const route = useRoute()
const store = useStore()
const userInfo = store.state.login.userInfo

if (route.query['deptId']) {
  const depts = store.state.login.depts
  for (const dept of depts) {
    if (dept.id == route.query['deptId']) {
      const empIds = []
      for (const emp of dept.emps) {
        empIds.push(emp.id)
      }
      query = { empIds }
    }
  }
  query = { ...query, createdTime: route.query.createdTime }
} else {
  query = { ...route.query }
}

const getEmp = async () => {
  let userList = localCache.getCache('empData')

  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id }
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'empIds'
  )
  userItem!.options = userOptions
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  dept!.isDisabled = userInfo.isManager != '1'
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const pageInfo = ref({ pageNo: 1, pageSize: 10 })

let queryParam = ref()
if (userInfo.isManager != '1') {
  queryParam.value = {
    empIds: userInfo.id,
    underTakeDate: [
      dayjs()
        .subtract(1, 'weeks')
        .startOf('date')
        .format('YYYY-MM-DD'),
      dayjs().endOf('date').format('YYYY-MM-DD')
    ],
    verifyResult: 'N',
    ...query,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }
} else {
  queryParam.value = {
    deptId: userInfo.deptId,
    fillDate: [toDay(), toDay()],
    underTakeDate: [
      dayjs()
        .subtract(1, 'weeks')
        .startOf('date')
        .format('YYYY-MM-DD HH:mm:ss'),
      dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
    ],
    ...query,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }
}
store.commit('system/changeQueyryInfo', queryParam.value)

const resetCb = () => {
  return queryParam.value
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb)
const router = useRouter()

const handleFillClick = (item: any) => {
  const reportUrl = router.resolve({
    path: '/main/report/newFundsVerification/fill',
    query: {
      ...item
    }
  }).href

  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.7
  const height = screenWidth * 0.7

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, '填报', options)
  if (popupWindow) {
    popupWindow.onbeforeunload = function () {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }
  }
}

const modalTitle = ref('新增')

let fundsVerificationIds: Array<number> = []
let exploitAccounts: string
// 多选框选择事件
const handleSlectionChange = (value: any[]) => {
  fundsVerificationIds = []
  exploitAccounts = ''
  for (const row of value) {
    fundsVerificationIds.push(row.id)
    exploitAccounts += row.exploitAccount + ', '
  }
  exploitAccounts = exploitAccounts.substring(0, exploitAccounts.length - 2)
}

const defaultInfo = ref({})
const pageModalRef = ref<InstanceType<typeof PageModal>>()
const handleBatchEditAccountBtnClick = (data: any) => {
  if (fundsVerificationIds.length == 0) {
    ElMessage({
      message: '请勾选修改的数据',
      type: 'warning'
    })
    return
  }

  defaultInfo.value = { oldExploitAccount: exploitAccounts.toString() }
  modalTitle.value = '批量修改'
  pageModalRef.value.dialogVisible = true
  pageModalRef.value.isBatch = true
}

const handleUpdateBatchData = async (formData: any) => {
  try {
    const formData2 = ref<any>({})
    await editPageData('/main/newFundsVerification/batch/update', {
      ...formData,
      ids: fundsVerificationIds
    })
    store.dispatch('system/getPageListAction', {
      pageName: 'newFundsVerification',
      queryInfo: store.state.system.queryInfo
    })
    pageModalRef.value.dialogVisible = false
  } finally {
    pageModalRef.value.confirmLoading = false
  }
}

const handleDetailData = (item: any) => {
  const reportUrl = router.resolve({
    path: '/main/report/newFundsVerification/detail',
    query: {
      ...item
    }
  }).href

  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.7
  const height = screenWidth * 0.7

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, '填报', options)
  if (popupWindow) {
    popupWindow.onbeforeunload = function () {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }
  }
}

const handleVerifyData = (item: any) => {
  ElMessageBox.confirm('', {
    title: '核实',
    confirmButtonText: '属实',
    cancelButtonText: '不属实',
    distinguishCancelAndClose: true
  })
    .then((action) => {
      if ('confirm' == action) {
        item.verifyResult = '1'
        let pageUrl = `/main/newFundsVerification/verify/${item.id}/${item.verifyResult}`
        editPageData(pageUrl, {}).then(() => {
          refreshFunc()
        })
      }
    })
    .catch((err) => {
      if ('cancel' == err) {
        item.verifyResult = '2'
      }
      let pageUrl = `/main/newFundsVerification/verify/${item.id}/${item.verifyResult}`
      editPageData(pageUrl, {}).then(() => {
        refreshFunc()
      })
    })
}

const refreshFunc = () => {
  store.dispatch('system/getPageListAction', {
    pageName: 'newFundsVerification',
    queryInfo: store.state.system.queryInfo
  })
}

const showViewer = ref(false)

const handleSortChange = (value: any) => {
  let orderBy = value.prop
  if (orderBy) {
    orderBy = orderBy.replace('Desc', '')
  }
  store.commit('system/changeOrderInfo', {
    orderBy: orderBy,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const previewSrcList = ref()
const handlePreview = (imgUrls: string) => {
  showViewer.value = true
  previewSrcList.value = imgUrls.split(',')
}
const closeViewer = () => {
  debugger
  showViewer.value = false
}
const isDetail = usePermission(pageName, 'detail')
const isVerify = usePermission(pageName, 'verify')

const showVerifyButton = (row: any) => {
  return isVerify && row.verifyResult != '1' && row.verifyResult != 'N'
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageSearch, {
        searchFormConfig: _unref(searchFormConfig),
        onResetBtnClick: _unref(handleResetClick),
        onSearchBtnClick: _unref(handleSearchClick)
      }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
      _createVNode(_component_PageContent, {
        ref_key: "pageContentRef",
        ref: pageContentRef,
        contentTableConfig: _unref(contentTableConfig),
        pageName: pageName,
        downFilename: "新资源资金量核实情况登记表.xlsx",
        onBatchEditAccountBtnClick: handleBatchEditAccountBtnClick,
        onDownBtnClick: _unref(handleDownBtnClick),
        onSelectionChange: handleSlectionChange,
        onSortChange: handleSortChange
      }, {
        proofImgUrls: _withCtx((scope) => [
          _createVNode(_component_el_link, {
            type: "warning",
            href: "javascript:;",
            onClick: ($event: any) => (handlePreview(scope.row.proofImgUrls)),
            disabled: 
            scope.row.proofImgUrls === null || scope.row.proofImgUrls === ''
          
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看")
            ]),
            _: 2
          }, 1032, ["onClick", "disabled"])
        ]),
        sHandler: _withCtx((scope) => [
          (showVerifyButton(scope.row))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleVerifyData(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("核实")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isDetail) && scope.row.id)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleDetailData(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_unref(isDetail) && !scope.row.id)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                type: "text",
                icon: "el-icon-edit",
                onClick: ($event: any) => (handleFillClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("填报")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["contentTableConfig", "onDownBtnClick"]),
      _createVNode(PageModal, {
        ref_key: "pageModalRef",
        ref: pageModalRef,
        defaultInfo: defaultInfo.value,
        modalConfig: _unref(modalConfig),
        title: modalTitle.value,
        pageName: "newFundsVerification",
        onUpdateBatchData: handleUpdateBatchData
      }, null, 8, ["defaultInfo", "modalConfig", "title"])
    ]),
    (showViewer.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": previewSrcList.value,
          onClose: closeViewer,
          infinite: false
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})